import { createSlice } from '@reduxjs/toolkit';

export const statePropName = 'migration';

const migrationSlice = createSlice({
  name: statePropName,
  initialState: {},
  reducers: {
    initMigration(state) {},
    featureStarted(state) {},
    startMigration(state) {},
    migrationBackendStarted(state) {},
    migrationBackendFinished(state) {},
    completeMigration(state) {},
  },
});

export const MigrationActions = migrationSlice.actions;
export default migrationSlice.reducer;
